import { uri } from '../data-util'
import * as xeon from './xeon'
import { rules } from './rules'
import { questions } from './questions'
import { kinetic } from './kinetic'
import { drugs } from './drugs'

// -----------------------------
// Checking url at startup
// -----------------------------
export function startup() {

  const params = uri.parse()

  return async ( dispatch, getState, api ) => {

    // -----------------------------------
    // Load previous xeon session or
    // create new one
    // -----------------------------------
    await dispatch( xeon.setId( params.xid ) )
    // Keep xeon.drugs if available in xid
    if ( params.xid ) {
      await dispatch( xeon.read( params.xid ) )
    }
    // Load or set drugs from params drugs or gtins
    if ( !params.xid ) {
      try {
        await dispatch( drugs( params.drugs ) )
      } catch ( e ) {
        console.log( ">", e.message )
        dispatch( { type: "xeon.drugs", data: {} } )
      }
    }

    // Check authorization for polypharmacy
    const { access } = getState()
    const authorized = access && access.sub && ( access.sub.includes( "standard" ) || access.sub.includes( "basic" ) )
    // New session and ignore previous xid not to override data
    if ( Object.keys( getState().xeon.drugs ).length > 4 && !authorized ) {
      dispatch( { type: "xeon.id", data: xeon.createId() } )
      dispatch( { type: "xeon.drugs", data: {} } )
      dispatch( { type: "xeon.rules", data: {} } )
      dispatch( { type: "xeon.faqs", data: {} } )
      dispatch( { type: "xeon.pmids", data: {} } )
      return "not-authorized"
    }

    // Inform interested view about loading
    dispatch( { type: "view.loading", data: true } )
    // Only refersh if substance are available
    await dispatch( rules() )
    // Check for questions to be asked
    await dispatch( questions( params.faqs ) )
    // Run in background
    await dispatch( kinetic() )
    // Inform interested view about loading
    dispatch( { type: "view.loading", data: false } )
    // Don't wait for loading
    return "go"
  }

}